module.exports = __webpack_public_path__ + "media/images/guide-1t-e650b8846c651fe678abe8228b9f3e8d.png";